export const MET_Header_Font_Family = "'BCSans', 'Noto Sans', Verdana, Arial, sans-serif";
export const MET_Header_Font_Weight = 700;
export const MET_Font_Weight = 500;
